'use client';

import type { MouseEventHandler, ReactElement } from 'react';
import { cloneElement, isValidElement } from 'react';

// import type { HackleEvent } from '@hackler/react-sdk';
import { useTrack } from '~/hooks/event';

interface Props extends React.HTMLProps<HTMLElement> {
  children: ReactElement<{ onClick?: MouseEventHandler<HTMLElement> }>;
  name: string;
  properties?: Record<string, unknown>;
  // hackle?: HackleEvent;
}

export function TrackClick({ children, name, properties, ...props }: Props) {
  const { track } = useTrack();

  if (!isValidElement(children)) return children;

  const handleClick: MouseEventHandler<HTMLElement> = (event) => {
    track(name, properties);

    props.onClick?.(event);
    if (children.props && typeof children.props.onClick === 'function') {
      return children.props.onClick(event);
    }

    return undefined;
  };

  return cloneElement(children, {
    onClick: handleClick,
  });
}
